/**
 * Returns a callback to show the next news elements.
 * @param {Element} component
 * @param {jQuery} $newsItems
 * @param {int} pageSize
 * @return {Function} A callback function
 */
const handleNextPage = (component, $newsItems, pageSize) => () => {
    const $hiddenItems = $newsItems.filter(':not([data-filtered]):hidden');
    $hiddenItems.slice(0, pageSize)
        .each((_, item) => {
            $(item)
                .show()
                .find('img').attr('src', $(item).attr('data-image'));
        });

    $newsItems.find('.grid').removeClass('grid--flip');
    $newsItems.filter(':visible:odd').find('.grid').addClass('grid--flip');

    // Remove the loader if there are no more news
    $(component)
        .find('.loader')
        .toggle($hiddenItems.length > pageSize);
};

export default handleNextPage;



// WEBPACK FOOTER //
// ./src/scripts/components/news-list/handleNextPage.js